module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/numbering.005566d5.svg";